import { Button } from 'components/button';
import { Row } from 'layouts/container';
import Iframe from 'react-iframe';
import { useNavigate } from 'react-router-dom';
import { useStore } from 'store';

export const CreateDevice = () => {
  const navigate = useNavigate();
  const { brand, branch } = useStore((state) => state);

  return (
    <div style={{ width: '100%', height: '90vh' }}>
      <header style={{ marginTop: '2rem', marginBottom: 20, }}>
        <Row alignItems={'center'} gap={8}>
          <div>
            <Button
              onClick={() => {
                navigate('/device-settings');
              }}
              style={{
                whiteSpace: 'nowrap',
                padding: '10px 10px',
                width: 'auto',
                background: '#FFFFFF',
                boxShadow: '0px 0px 4px #D1D1D3',
                borderRadius: '6px',
                gap: '4px',
                fontWeight: '500',
                color: '#474747',
                height: 'auto'
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                width={16}
                height={16}
                strokeWidth="1.5"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
                />
              </svg>
            </Button>
          </div>
        </Row>
      </header>
      <Iframe
        url={`${process.env.REACT_APP_PAYMENT_ONBOARDING_URL}?buisnessId=${brand?.business_id}&brandId=${brand?.id}&branchId=${branch?.id}&level=branch&action=Onboard_Device`}
        width="100%"
        height="100%"
        id="myId"
        className="myClassname"
        display="block"
        position="relative"
        overflow="hidden"
        frameBorder={0}
      />
    </div>
  );
};
